/* eslint-disable linebreak-style */
const CartContextDefault = {
  notificationCartCount: 0,
  setNotificationCartCount: () => {},
}

export default CartContextDefault